import Vue from 'vue'
import Request from '@Utils/request'
import Dispatcher from '@Utils/dispatcher'
import components from '../components'
import Modules from '../modules'

export default class App {
  constructor () {
    this.request = Request
    this.dispatcher = new Dispatcher()
  }

  init (url) {
    this.url = url;

    this.vue = new Vue({
      el: '#app',
      url,
      components
    })

    this.inview = new Modules.InView();

    this.inview.observe('img[data-src]', (img) => {
      img.src = img.dataset.src
    });

    
    this.inview.observe('div[data-container]', (element) => {
      element.classList.add('show');
    });

    this.inview.observe('div[data-aboutData]', (element) => {
      document.getElementById('aboutMainImage').classList.add('show');
      element.classList.add('show');
    });

    this.inview.observe('div[data-aboutData2]', (element) => {
      element.classList.add('show');
    });

    this.inview.observe('div[data-main]', (el) => {
      el.style = "background-image: url(" + el.dataset.main + ")";
      document.getElementById('jumboLeftCol').style.opacity = 1;
      setTimeout( function() { 
        document.getElementById('jumboLeftColLogo').classList.add('show');
      },100);
      setTimeout( function() { 
        document.getElementById('jumboLeftColMenu').classList.add('show');
      },350);
      setTimeout( function() { 
        document.getElementById('jumboLeftColLanguage').classList.add('show');
        document.getElementById('carouselExampleSlidesOnly').style.opacity  = 1;
      },600);
      setTimeout( function() { 
        document.getElementById('jumboFirstFrame').classList.add('show');
      },1500);
    });

    this.inview.observe('div[data-news]', (el) => {
      let factor = 0;
      if(document.getElementById('newsContainer3')) {
        document.getElementById('newsContainer3').classList.add('show');
        factor = 1;
      }
      if(document.getElementById('newsContainer2')) {
        setTimeout( function() {
          document.getElementById('newsContainer2').classList.add('show');
        }, (500 * factor));
        factor = factor + 1;
      }

      if(document.getElementById('newsContainer1')) {
        setTimeout( function() {
          document.getElementById('newsContainer1').classList.add('show');
        }, (500 * factor));
      }

      setTimeout( function() {
        document.getElementById('newsletterForm').classList.add('show');
      }, ((500 * factor) + 1000));

    });

    this.inview.observe('div[data-referenc]', (el) => {
      el.classList.add('show');
    });

    this.inview.observe('div[data-contact]', (el) => {
      el.style = "background-image: url(" + el.dataset.contact + ")";
      el.classList.add('show');
      setTimeout( function() {
        document.getElementById('contactForm').classList.add('show');
      }, 700);
    });

  }
}
